import BaseModel from './BaseModel'
import {currentConseillerId} from '@/helpers'

export default class AlerteModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      ID_PROSPECT: null,
      DATE_HEURE: '',
      MESSAGE: '',
      ID_CONSEILLER: currentConseillerId()
    }
    super(data, relation, fields)
  }
}
